import { useRef } from 'react'

/**
 * A random seed generated once per mount and kept stable across re-renders.
 * Pair with `pickStable` to rotate copy variants without flicker when the tile
 * re-renders (e.g. on Pusher/data updates).
 */
export function useStableSeed(): number {
  const seedRef = useRef<number | null>(null)
  if (seedRef.current === null) {
    seedRef.current = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
  }
  return seedRef.current
}
